const editlibraryConstants = {
    DEBOUNCE_INTERVAL: 500,
    MIN_SEARCH_LENGTH: 3,
    MAX_LIBRARY_SIZE: 100
}

export default editlibraryConstants